module.exports = __webpack_public_path__ + "img/store-windows.125dd69e.png";